import { DimeProvider } from '@office-start/dime-service';
import OfficeFluentProvider, { OfficeFluentProviderProps } from '@office-start/office-fluent-provider';
import React from 'react';

type withOfficeFluentProviderOptions = {
    isRefreshEnabled: boolean;
    legacyClassName?: string;
};

export const withOfficeFluentProvider =
    <T extends object>(Component: React.FC<T>, options: withOfficeFluentProviderOptions): React.FC<T> =>
    (props: T) => {
        // With no refresh, respect the legacy class name
        let officeFluentProviderProps: OfficeFluentProviderProps = {
            className: options.legacyClassName
        };

        // When refresh is enabled, set fluent provider background to transparent and ignore the legacy class name
        if (options.isRefreshEnabled) {
            officeFluentProviderProps = {
                className: undefined,
                style: { backgroundColor: 'transparent'}
            };
        }

        return (
            <OfficeFluentProvider {...officeFluentProviderProps}>
                <DimeProvider>
                    <Component {...props} />
                </DimeProvider>
            </OfficeFluentProvider>
        );
    };
